export const FETCH_API_KEY_REQUEST = "fetchApiKeyConstants/FETCH_API_KEY_REQUEST";
export const FETCH_API_KEY_SUCCESS = "fetchApiKeyConstants/FETCH_API_KEY_SUCCESS";
export const FETCH_API_KEY_FAIL = "fetchApiKeyConstants/FETCH_API_KEY_FAIL";
